import { render, staticRenderFns } from "./bitacora.vue?vue&type=template&id=4d06d658&scoped=true"
import script from "./bitacora.vue?vue&type=script&lang=js"
export * from "./bitacora.vue?vue&type=script&lang=js"
import style0 from "./bitacora.vue?vue&type=style&index=0&id=4d06d658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d06d658",
  null
  
)

export default component.exports